import React from 'react';

import getValue from 'lodash.get';

import Typography from '@mui/material/Typography';

const Field = ({
	Registry,
	type,
	values,
	value,
	name,
	onChange,
	readOnly,
	readOnlyFormatter = v => v,
	prerequisites,
	errors,
	...fieldProps
}) => {
	const Component = Registry.getField(type);

	if (!Component) {
		return <div>Component {type} not yet implemented</div>;
	}
	let v = value;
	if (v == undefined) {
		const valueFromValues = getValue(values, name);
		// necessary to display 0 in numberTextField
		if (valueFromValues === 0) {
			v = valueFromValues;
		} else {
			v = valueFromValues || '';
		}
	}

	const error = getValue(errors, name);
	const errorMessage = Array.isArray(error) ? error[0] : error;
	const processedProps = {};

	// if (!shouldShow(values, prerequisites)) {
	//   return null;
	// }

	if (!Component) {
		<div className="nf-warning-no-exist">{type} field does not exist yet or is not loaded.</div>;
	}

	const parseExpression = v => {
		if (v === 'true') v = true;
		if (v === 'false') v = false;
		return v;
	};

	Object.keys(fieldProps).forEach(p => {
		processedProps[p] = parseExpression(fieldProps[p]);
	});

	if (readOnly) return <Typography sx={{ padding: 1 }}>{readOnlyFormatter(v)}</Typography>;

	return (
		<Component {...processedProps}
			name={name}
			value={v}
			values={values}
			errorMessage={errorMessage}
			onChange={onChange} />
	);
};

export default Field;
